<template>
  <section
    class="new-case-view case-creation"
    id="single-case-view"
    v-loading="loading"
  >
    <div class="case-creation__step case-creation__patient-information">
      <div class="container-sm">
        <div class="case-creation__card">
          <div class="case-creation__heading edit-view">
            <div class="title-with-icon">
              <span class="icon">
                <img
                  src="@/assets/images/icons/icon-patient-info.svg"
                  alt="icon"
                  class="img-fluid"
                />
              </span>
              <h3 class="title">
                {{ getSingleLab ? getSingleLab.name : "--" }}
              </h3>
            </div>
          </div>
          <div class="case-creation__body pb-0">
            <div class="vue-data">
              <el-row :gutter="20">
                <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Lab Code</h4>
                    <p class="value">
                      {{ getSingleLab ? getSingleLab.lab_code : "--" }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Phone Number</h4>
                    <p class="value">
                      {{ getSingleLab ? getSingleLab.phone : "--" }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Email</h4>
                    <p class="value">
                      {{ getSingleLab ? getSingleLab.email : "--" }}
                    </p>
                  </div>
                </el-col>

                <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Fax</h4>
                    <p class="value">
                      {{ getSingleLab ? getSingleLab.fax : "--" }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="8" :lg="8" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Address Line 1</h4>
                    <p class="value">
                      {{ getSingleLab ? getSingleLab.address_line_1 : "--" }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="8" :lg="8" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Address Line 2</h4>
                    <p class="value">
                      {{ getSingleLab ? getSingleLab.address_line_2 : "--" }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">County</h4>
                    <p class="value">
                      {{ getSingleLab ? getSingleLab.country : "--" }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Zip</h4>
                    <p class="value">
                      {{ getSingleLab ? getSingleLab.zip : "--" }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">State</h4>
                    <p class="value">
                      {{ getSingleLab ? getSingleLab.state : "--" }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">City</h4>
                    <p class="value">
                      {{ getSingleLab ? getSingleLab.city : "--" }}
                    </p>
                  </div>
                </el-col>

                <el-col :xl="8" :lg="8" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Director</h4>
                    <p class="value">
                      {{ getSingleLab ? getSingleLab.director : "--" }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">CLIA Id</h4>
                    <p class="value">
                      {{ getSingleLab ? getSingleLab.clia_id : "--" }}
                    </p>
                  </div>
                </el-col>

                <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Website</h4>
                    <p class="value">
                      {{ getSingleLab ? getSingleLab.website : "--" }}
                    </p>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters("labs", ["getSingleLab"]),
    ...mapGetters("auth", ["getAuthenticatedUser","getUserPrimaryLabId"]),
  },
  mounted() {
    this.$store.dispatch("labs/fetchSingleLab", this.getUserPrimaryLabId);
  },
};
</script>
